module.exports = __webpack_public_path__ + "img/pic_top_right.0ba74c25.png";